


import { Contact } from "../../interfaces/DTO/crm/contact";
import { FamilyMember } from "../../interfaces/DTO/crm/family";
import { useIdStore, useViewedTypeStore } from "../../stores/selectedToViewStore";
import { useContacts } from "../crm/useContacts";
import { useFamilyMembersByFamily } from "../crm/useFamilyMembers";


export interface ActiveUserOrFamilyDataResult {
  contacts: Contact[]; // ✅ ה־User הוחלף ב־Contact
  familyMembers: FamilyMember[];
  isLoading: boolean;
  isError: boolean;
}

export const useActiveUserOrFamilyData = (): ActiveUserOrFamilyDataResult => {
  const viewedType = useViewedTypeStore((state) => state.viewedType);
  const familyIdOrUserId = useIdStore((state) => state.id);

  // ✅ שליפת כל אנשי הקשר
  const {
    data: allContacts = [],
    isLoading: contactsLoading,
    isError: contactsError,
  } = useContacts();

  // ✅ שליפת חברי משפחה (מותנה ב־viewedType === "FAMILY")
  const {
    data: familyMembers = [],
    isLoading: familyLoading,
    isError: familyError,
  } = useFamilyMembersByFamily(familyIdOrUserId, viewedType === "FAMILY");

  // ✅ אנשי קשר נוכחיים לפי מצב תצוגה
  const contacts =
    viewedType === "USER"
      ? allContacts.filter((c) => c.id === familyIdOrUserId)
      : allContacts.filter((c) =>
          familyMembers.some((member) => member.contact_id === c.id)
        );

  const isLoading =
    contactsLoading || (viewedType === "USER" ? false : familyLoading);

  const isError =
    contactsError || (viewedType === "USER" ? false : familyError);

  return {
    contacts: contacts,
    familyMembers,
    isLoading,
    isError,
  };
};
